import { z } from 'zod';
import { baseAreaSchema } from './IBaseArea';
import { AreaTypeEnum } from './AreaType.enum';

// Schemas (source of truth)
/**
 * Area schema for API responses.
 * Extends baseAreaSchema with areaType which is added by AreaMergeDataHandler during enrichment.
 */
export const areaResponseSchema = baseAreaSchema.extend({
	areaType: z.nativeEnum(AreaTypeEnum).optional(),
});

// Types (derived from schemas)
export type IAreaResponse = z.infer<typeof areaResponseSchema>;
